import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ProductFacetNavigationComponent } from '@spartacus/storefront';
import { HisenseFacetService } from '../../services/facet.service';

@Component({
  selector: 'cx-product-facet-navigation',
  templateUrl: 'product-facet-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HisenseProductFacetNavigationComponent extends ProductFacetNavigationComponent {
  protected facetService = inject(HisenseFacetService);
}
